import { TeamType } from 'common/dto-types/team-dto';

const TeamTypeCell = ({ value }: { value: number }): JSX.Element => {
    switch (value) {
        case TeamType.Club:
            return <p>Club</p>;
        case TeamType.National:
            return <p>National</p>;
        case TeamType.Unknown:
        default:
            return <p>Unknown</p>;
    }
};

export default TeamTypeCell;
